import { mapState } from 'vuex'
import * as moment from 'moment'
import * as Sentry from '@sentry/vue'
import featuresByPlan from './featuresByPlan'
import featuresByPlanForSingaporean from './featuresByPlan.singapore'
import featuresByPlanForVietnamese from './featuresByPlan.vietnam'
import featuresByPlanForEur from './featuresbyPlan.eur'
import contentPlan from './contentPlan'
import {
} from '@/constant/slideTypes'
import config from '@/config'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      planUser: (state) => state.currentUser.plan,
      currentUser: (state) => state.currentUser,
      planBenefit: (state) => state.planBenefit,
    }),
    fromJustNow() {
      if (this.isUserRegisterBeforeGoLivePricingOrPlanUser) {
        return 7.95
      }
      if (this.isUserVietNam) {
        return '200,000'
      }
      if (this.isUserSingapore) {
        return 10.75
      }
      if (this.isUserEurope) {
        return 7.25
      }
      return 7.95
    },
    isUserRegisterBeforeGoLivePricingOrPlanUser() {
      try {
        if (!this.currentUser.myPlan) {
          return false
        }
        const activeSub = this.currentUser.myPlan.subscription
        // if user have active sub and currency is eur  => new flow pricing
        if (activeSub.currency === 'eur') {
          return false
        }
        // if user have active sub and created time sub before time go live => old flow pricing
        if (
          activeSub &&
          moment(activeSub.created).isBefore(config.timeGoLivePricing)
        ) {
          return true
        }
        return false
      } catch (e) {
        Sentry.captureException(e)
        return true
      }
    },

    featuresByPlan() {
      let features = featuresByPlan
      if (this.isUserVietNam) {
        features = featuresByPlanForVietnamese
      }
      if (this.isUserSingapore) {
        features = featuresByPlanForSingaporean
      }
      if (this.isUserEurope) {
        features = featuresByPlanForEur
      }
      return this.mergePlans(features, contentPlan)
    },
    isUserVietNam() {
      return ['Vietnam'].includes(this.currentUser.country)
    },
    isUserSingapore() {
      return ['Singapore'].includes(this.currentUser.country)
    },
    isUserEurope() {
      return [
        'Austria',
        'Belgium',
        'Croatia',
        'Cyprus',
        'Estonia',
        'Finland',
        'France',
        'Germany',
        'Greece',
        'Ireland',
        'Italy',
        'Latvia',
        'Lithuania',
        'Luxembourg',
        'Malta',
        'Netherlands',
        'Portugal',
        'Slovakia',
        'Slovenia',
        'Spain',
      ].includes(this.currentUser.country)
    },
    isUserApplyNewPayment() {
      if (
        this.currentUser.plan === 'free' &&
        this.isUserInZoneApplyNewPayment
      ) {
        return true
      }
      if (this.isUserRegisterBeforeGoLivePricingOrPlanUser) {
        return false
      }
      return this.isUserInZoneApplyNewPayment
    },
    isUserInZoneApplyNewPayment() {
      return this.isUserSingapore || this.isUserVietNam || this.isUserEurope
    },
    fullSymbolCurrency() {
      if (this.isUserRegisterBeforeGoLivePricingOrPlanUser) {
        return 'USD'
      }
      if (this.isUserSingapore) {
        return 'SGD'
      }
      if (this.isUserVietNam) {
        return 'VND'
      }
      if (this.isUserEurope) {
        return 'EUR'
      }
      return 'USD'
    },
    symbolCurrency() {
      if (this.isUserRegisterBeforeGoLivePricingOrPlanUser) {
        return '$'
      }
      if (this.isUserSingapore) {
        return 'S$'
      }
      if (this.isUserVietNam) {
        return '₫'
      }
      if (this.isUserEurope) {
        return '€'
      }
      return '$'
    },
  },
  methods: {
    isForPairPlan() {
      return false
    },
    mergePlans(features, content) {
      const merged = {}
      const planMapping = {
        annual: 'normal',
        monthly: 'normal',
        educational: 'educational',
      }

      Object.keys(features).forEach((planType) => {
        const contentType = planMapping[planType]

        if (
          features[planType] &&
          features[planType].planPrices &&
          content.card[contentType]
        ) {
          merged[planType] = {
            planPrices: features[planType].planPrices.map((plan) => {
              const matchingContent = content.card[contentType].find(
                (contentData) => contentData.column === plan.column,
              )
              return matchingContent ? { ...plan, ...matchingContent } : plan
            }),
          }
        } else {
          console.error(`Missing data for plan type: ${planType} or content type: ${contentType}`)
        }
      })

      return {
        ...merged,
        plansDropdown: content.plansDropdown,
        comparePlan: content.comparePlan,
      }
    },
    setTranslationforPlainText(text) {
      // Check if text is a number, boolean, or non-string
      if (typeof text === 'number' ||
          typeof text === 'boolean' ||
          typeof text !== 'string') {
        return text
      }
      // Check if the text can be converted to a valid number
      const num = Number(text)
      if (!Number.isNaN(num)) {
        return text
      }
      // If none of the above, return the translation
      return this.$i18nPresenter.t(text)
    },
  },
}
